import React from 'react';
import {ArticleApi, ArticleDto, ArticleStatus, CongressTable} from '../../scaffold';
import {Modal, Space, Table, Tag} from 'antd';
import {Result} from 'ahooks/lib/useAntdTable';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';
import ArticleEditForm from './EditForm';
import useAuth from '../../utils/AuthContext';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import CongressTableEditForm from './EditForm';
import DeleteArticleBtn from '../article/DeleteBtn';
import DeleteCongressTableBtn from './DeleteBtn';

export default function CongressTableTable(props: {antDTable: Result<CongressTable>}) {
  const {tableProps, search, loading} = props.antDTable;
  const [editArticle, _editArticle] = React.useState<ArticleDto>();
  return (
    <div>
      <Table<ArticleDto> {...tableProps} rowKey={'id'} bordered size={'small'}>
        <Table.Column<CongressTable> title="ID" dataIndex="id" sorter width={80} />
        <Table.Column<CongressTable> title="姓名" render={(_, item) => <Text strong>{item.name}</Text>} />
        <Table.Column<CongressTable> title="学会职位" dataIndex={'job'} />
        <Table.Column<CongressTable> title="工作单位" dataIndex={'organizationName'} />
        <Table.Column<CongressTable> title="手机号" dataIndex={'telephone'} />
        <Table.Column<CongressTable> title="出生年月" dataIndex={'birthDate'} render={(_, item) => moment(item.birthDate).format('YYYY-MM-DD')} />
        <Table.Column<CongressTable> title="提交时间" width={200} dataIndex={'createdTime'} />
        <Table.Column<ArticleDto>
          title="操作选项"
          width={200}
          render={(text, row) => {
            return (
              <Space>
                <a onClick={() => _editArticle(row)}>查看</a>
                <DeleteCongressTableBtn id={row.id as number} refresh={props.antDTable.refresh} />
              </Space>
            );
          }}
        />
      </Table>
      <Modal title={'详情'} destroyOnClose width={1200} visible={!!editArticle} onCancel={() => _editArticle(undefined)} footer={false}>
        {editArticle && (
          <CongressTableEditForm
            table={editArticle}
            suMode
            onSuccess={() => {
              _editArticle(undefined);
              props.antDTable.refresh();
            }}
          />
        )}
      </Modal>
    </div>
  );
}
